import { Page } from '~/components/Page'
import { Logo } from './Logo'
import { Trailers } from './Trailers'
import { HeroButton } from './Buttons'
import { AsSeenOn } from './AsSeenOn'
import { GameplayVideo } from './GameplayVideo'
import { PartnersAndInvestors } from './PartnersAndInvestors'
import { PickASide } from './PickASide'
import { News } from './News'

export const LandingPage = () => {
    return (
        // No header. The mobile bar already carries the BR1 skull on the left, and it links here —
        // so on the home page the word "BR1" in the middle of the bar was a label for the page you
        // are already on, sitting next to the logo that says the same thing.
        <Page className='flex flex-col'>
            <Logo />
            <Trailers />
            <HeroButton />
            <AsSeenOn />
            <GameplayVideo />
            <PartnersAndInvestors />
            <PickASide />
            <News />
        </Page>
    )
}
